import { useMutation, useQueryClient } from '@tanstack/react-query'
import { generatePath, useHistory } from 'react-router-dom'
import { AxiosError } from 'axios'

import { AppRoute } from 'routing/AppRoute.enum'
import { Mutations } from 'api/mutations.enum'
import { Queries } from 'api/queries.enum'
import { CreatePulseSurveyResponse } from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { createPulseSurvey } from 'api/actions/pulseSurveys/pulseSurveysActions'
import { generateCompanyURI } from 'sagas/helpers/generateCompanyURI'
import { usePulseSurveys } from 'hooks/usePulseSurveys'

const DEFAULT_PULSE_SURVEY_TITLE = 'Untitled'
const DEFAULT_PULSE_SURVEY_DESCRIPTION = ''

export const useCreatePulseSurvey = () => {
    const history = useHistory()

    const queryClient = useQueryClient()

    const { onChangeActivePulseSurvey } = usePulseSurveys()

    const mutation = useMutation<CreatePulseSurveyResponse, AxiosError, void>({
        mutationFn: () =>
            createPulseSurvey({
                title: DEFAULT_PULSE_SURVEY_TITLE,
                description: DEFAULT_PULSE_SURVEY_DESCRIPTION,
            }),
        mutationKey: [Mutations.createPulseSurvey],
        onSuccess: async (pulseSurvey) => {
            await queryClient.invalidateQueries([Queries.getPulseSurveys])

            onChangeActivePulseSurvey(pulseSurvey)

            history.push(generateCompanyURI(generatePath(AppRoute.PulseSurveyCreate, { id: pulseSurvey.uuid })))
        },
    })

    return mutation
}
